export default {
  title: '航线管理',

  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '航线代码、中文名、英文名',
    routeType: '航线类型',
    routeTypePlaceholder: '选择航线类型',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  actions: {
    addRoute: '新增航线',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    recordsCount: '共 {count} 条记录',
    enable: '启用',
    disable: '禁用',
    associatePort: '关联港口'
  },

  table: {
    routeCode: '航线代码',
    routeNameCn: '航线名称（中文）',
    routeNameEn: '航线名称（英文）',
    routeType: '航线类型',
    status: '状态',
    operation: '操作'
  },

  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  routeType: {
    sea: '海运航线',
    air: '空运航线'
  },

  confirm: {
    toggleStatus: '确定要{action}此航线吗？'
  },

  modal: {
    title: '新增航线',
    confirmText: '确认添加',
    searchPlaceholder: '搜索航线代码、名称',
    selected: '已选择 {count} 条航线',
    filterTip: '💡 提示：可以通过关键词和航线类型进行筛选，找到所需的航线数据'
  },

  messages: {
    loadError: '加载航线数据失败',
    searchError: '搜索航线失败',
    selectToAdd: '请选择要添加的航线',
    associateSuccess: '关联航线成功',
    associateError: '关联航线失败',
    statusToggleSuccess: '状态切换成功',
    statusToggleError: '状态切换失败',
    selectToEnable: '请选择要启用的航线',
    batchEnableSuccess: '批量启用成功',
    batchEnableError: '批量启用失败',
    selectToDisable: '请选择要禁用的航线',
    batchDisableSuccess: '批量禁用成功',
    batchDisableError: '批量禁用失败'
  },

  detail: {
    title: '航线港口绑定配置',
    saveButton: '保存配置',
    basicInfo: '航线基本信息',
    routeDescription: '航线描述',
    routeDescriptionPlaceholder: '请输入航线描述信息（最多100字）',
    portBinding: '港口绑定配置',
    polBinding: '起运港绑定',
    podBinding: '目的港绑定',
    selectPolPlaceholder: '请选择起运港',
    selectPodPlaceholder: '请选择目的港',
    addPort: '添加港口',
    noPortSelected: '暂未选择港口',
    searchPortPlaceholder: '搜索港口名称或代码',
    enterSearchKeyword: '请输入搜索关键词',
    noSearchResult: '未找到匹配的港口',
    portAlreadyAdded: '该港口已添加',
    saveSuccess: '保存成功',
    saveError: '保存失败'
  }
}
